<script setup lang="ts">
export interface Props {
  width?: string;
}

withDefaults(defineProps<Props>(), {
  width: '26.5rem',
});

const emits = defineEmits(['mouseover', 'mouseleave']);

const showPopover = defineModel<boolean>({ required: true });
</script>

<template>
  <div class="popover-panel">
    <div class="popover-panel-trigger">
      <slot name="trigger"></slot>
    </div>
    <div
      class="popover-panel-container"
      data-cy="popover-panel-container"
      v-if="showPopover"
      @mouseover="emits('mouseover')"
      @mouseleave="emits('mouseleave')">
      <div class="popover-panel-container-content">
        <div class="popover-panel-container-header">
          <div class="popover-panel-container-title">
            <slot name="title"></slot>
          </div>
          <div class="popover-panel-container-action">
            <slot name="action"></slot>
          </div>
        </div>
        <div class="popover-panel-container-body">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.popover-panel {
  &-trigger {
    cursor: pointer;
  }

  &-container {
    overflow: hidden;
    position: absolute;

    top: 54px;
    right: -2px;
    z-index: 4;

    background-color: transparent;

    &-content {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
      height: 100%;
      min-width: v-bind(width);
      padding: 1.5rem;
      border-radius: 0.25rem;
      border: 1px solid var(--border-color);
      background-color: var(--primary-bg-color);
    }

    &-title {
      @include center-flex;

      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      text-align: left;
    }

    &-action {
      @include center-flex;
    }

    &-header {
      display: flex;
      justify-content: space-between;
    }

    &-body {
      padding-top: 0rem;
      padding-bottom: 0rem;
      text-align: left;
    }
  }
}
</style>
